import { Observable } from 'rxjs'
import { catchError, shareReplay } from 'rxjs/operators'
import { DEFAULT_API_CACHE_TIMEOUT_MS } from 'src/config/global-config'

export interface TimestampObservableCache<T> {
  expires: number
  observable: Observable<T>
}

export class TimedCache<T> {

  private cache: { [id: number | string]: TimestampObservableCache<T> } = {}

  clear(): void {
    this.cache = {}
  }

  delete(key: number | string): void {
    delete this.cache[key]
  }

  get(
    key: number | string,
    observableFactory: () => Observable<T>,
    timeout = DEFAULT_API_CACHE_TIMEOUT_MS
  ): Observable<T> {
    const cachedItem = this.getCacheItem(key)
    if (cachedItem) {
      return cachedItem
    }

    const newObs = observableFactory().pipe(
      shareReplay({ bufferSize: 1, refCount: false }),
      catchError((err: any) => {
        delete this.cache[key]
        throw err
      })
    )

    this.cache[key] = {
      expires: Date.now() + timeout,
      observable: newObs,
    }

    return newObs
  }

  private getCacheItem(key: number | string): Observable<T> | undefined {
    const cacheItem = this.cache[key]

    if (!cacheItem) {
      return undefined
    }

    if (cacheItem.expires <= Date.now()) {
      delete this.cache[key]
      return undefined
    }

    return cacheItem?.observable
  }
}
